<div class="card">
    <div class="card-header bg-danger accordion-links" [ngClass]="defaultDisplay">
        <a href='javascript:void(0)' (click)="showHideErrorsWarnings()" role="link" tabindex="0" aria-label="show or hide errors and warnings"
        (keydown.enter)="showHideErrorsWarnings()">
            <span class="text-danger" tabindex="0">Validation errors and warnings </span>
            <span class="text-danger" *ngIf="!isHideErrorsWarnings">
                <i class="fas fa-chevron-up"></i>
            </span>
            <span class="text-danger" *ngIf="isHideErrorsWarnings">
                <i class="fas fa-chevron-down"></i>
            </span>
        </a>
    </div>
    <div class="pt-0 pb-0" [hidden]="isHideErrorsWarnings" tabindex="0">
            <div [hidden]='!splErrorMessages || splErrorMessages.length === 0'>
                <div>
                    <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)"
                    target=".e-tooltipcolumn" [enableHtmlParse]="false">
                      <ejs-grid #errorGrid
                                [dataSource]='splErrorMessages'
                                [allowScrolling]="true"
                                [allowPaging]="false"
                                [allowSorting]="true"
                                height="350px"
                                (queryCellInfo)='customiseCell($event)'>
                          <e-columns>
                              <e-column [customAttributes]="clipmodecolumn" field='fieldName' clipMode="EllipsisWithTooltip" headerText='Field name' textAlign='Left' width=100></e-column>
                              <e-column [customAttributes]="clipmodecolumn" field='message' clipMode="EllipsisWithTooltip" headerText='Message' textAlign='Left' width=200></e-column>
                              <e-column [customAttributes]="clipmodecolumn" field='messageType' clipMode="EllipsisWithTooltip" headerText='Type' textAlign='left' width=40></e-column>
                          </e-columns>
                      </ejs-grid>
                    </ejs-tooltip>
                </div>
            </div>
    </div>
</div>
